/**
 * @generated SignedSource<<1423bf935c9c2c3bc852a3cee96fe93f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DismissMutationProgressIndicatorInput = {
  clientMutationId?: string | null | undefined;
  dismissBulkCommunicationProgressIndicator?: boolean | null | undefined;
  dismissBulkUploadNewEnrolmentsIndicator?: boolean | null | undefined;
  dismissGenerateDraftIndicator?: boolean | null | undefined;
  dismissGenerateGoogleRegistersIndicator?: boolean | null | undefined;
  dismissGenerateRegistersForNewBlockIndicator?: boolean | null | undefined;
  dismissMatchPaymentsIndicator?: boolean | null | undefined;
  dismissReadInRegistersIndicator?: boolean | null | undefined;
  dismissSendDraftIndicator?: boolean | null | undefined;
  dismissSendRemindersIndicator?: boolean | null | undefined;
  dismissTeacherBulkCommunicationProgressIndicator?: boolean | null | undefined;
};
export type DismissMutationProgressIndicatorMutation$variables = {
  input: DismissMutationProgressIndicatorInput;
};
export type DismissMutationProgressIndicatorMutation$data = {
  readonly dismissMutationProgressIndicator: {
    readonly errors: any | null | undefined;
    readonly profileGroup: {
      readonly bulkUploadNewEnrolmentsProgress: number | null | undefined;
      readonly generateDraftsProgress: number | null | undefined;
      readonly generateGoogleRegistersProgress: number | null | undefined;
      readonly generateRegistersForNewBlockProgress: number | null | undefined;
      readonly id: string;
      readonly matchPaymentsProgress: number | null | undefined;
      readonly readInRegistersProgress: number | null | undefined;
      readonly sendBulkCommunicationProgress: number | null | undefined;
      readonly sendDraftsProgress: number | null | undefined;
      readonly sendRemindersProgress: number | null | undefined;
      readonly sendTeacherBulkCommunicationProgress: number | null | undefined;
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type DismissMutationProgressIndicatorMutation = {
  response: DismissMutationProgressIndicatorMutation$data;
  variables: DismissMutationProgressIndicatorMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DismissMutationProgressIndicatorPayload",
    "kind": "LinkedField",
    "name": "dismissMutationProgressIndicator",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileGroupNode",
        "kind": "LinkedField",
        "name": "profileGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "generateDraftsProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sendDraftsProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sendRemindersProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "matchPaymentsProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "generateGoogleRegistersProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "readInRegistersProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bulkUploadNewEnrolmentsProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "generateRegistersForNewBlockProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sendBulkCommunicationProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sendTeacherBulkCommunicationProgress",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DismissMutationProgressIndicatorMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DismissMutationProgressIndicatorMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f358e8e53d2c3db7d0aac7cedcd99e04",
    "id": null,
    "metadata": {},
    "name": "DismissMutationProgressIndicatorMutation",
    "operationKind": "mutation",
    "text": "mutation DismissMutationProgressIndicatorMutation(\n  $input: DismissMutationProgressIndicatorInput!\n) {\n  dismissMutationProgressIndicator(input: $input) {\n    success\n    errors\n    profileGroup {\n      id\n      generateDraftsProgress\n      sendDraftsProgress\n      sendRemindersProgress\n      matchPaymentsProgress\n      generateGoogleRegistersProgress\n      readInRegistersProgress\n      bulkUploadNewEnrolmentsProgress\n      generateRegistersForNewBlockProgress\n      sendBulkCommunicationProgress\n      sendTeacherBulkCommunicationProgress\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f1b1b12548e2f5ab03508e3dfc825d8";

export default node;
